/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (
  page,
  sortAttr,
  label,
  search,
  wallet_contacts = false,
  ignoreEmptyEmail = false
) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  if (wallet_contacts) {
    params = `${params}&wallet_contacts=${wallet_contacts}`;
  }

  if (ignoreEmptyEmail) {
    params = `${params}&ignore_empty_email=true`;
  }

  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(
    page,
    sortAttr = 'name',
    label = '',
    wallet_contacts = false,
    ignoreEmptyEmail = false
  ) {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      '',
      wallet_contacts,
      ignoreEmptyEmail
    )}`;
    return axios.get(requestURL);
  }

  getCampaignListContacts(page = 1, contactsIds = []) {
    return axios.get(`${this.url}/unselected`, {
      params: { page, exclude_ids: contactsIds.join(',') },
    });;
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  update(contactId, contactData) {
    return axios.patch(`${this.url}/${contactId}`, contactData);
  }

  search(
    search = '',
    page = 1,
    sortAttr = 'name',
    label = '',
    ignoreEmptyEmail = false
  ) {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search,
      false,
      ignoreEmptyEmail
    )}`;
    return axios.get(requestURL);
  }

  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }

  importContacts(file, selectedWalletId, duplicateStrategy = 'ignore', selectedLabelId = null) {
    const formData = new FormData();
    formData.append('import_file', file);
    formData.append('user_id', selectedWalletId);
    formData.append('duplicate_strategy', duplicateStrategy);
    if (selectedLabelId) {
      formData.append('label_id', selectedLabelId);
    }

    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getDataImportStatus(importId) {
    return axios.get(`${this.baseUrl()}/data_imports/${importId}`);
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAllContacts(allContacts) {
    return axios.post(`${this.url}/destroy_multiple_contacts`, {
      contacts_ids: allContacts,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts() {
    return axios.get(`${this.url}/export`);
  }

  checkContact(url, phone) {
    return axios.get(`${url}/check-user/${phone}`);
  }
}

export default new ContactAPI();
